import React from 'react';
import Select from 'react-select';
import {
  Grid,
  Container,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Paper
} from '@mui/material';
import { validateLedgerCurrentYear } from 'utils/validationUtils';
import Loader from 'utils/Loader';
import DivisionWiseOutstandingControllerNew from 'pages/Controller/DivisionWiseOutstandingControllerNew';

// Grouping function
const groupBy = (array, keys) => {
  return array.reduce((result, item) => {
    const crdr = item.drAmount > 0 ? 'Dr' : 'Cr';
    const key = keys.map((k) => (k === 'crdr' ? crdr : item[k])).join(' | ');
    if (!result[key]) result[key] = [];
    result[key].push(item);
    return result;
  }, {});
};

// Group total function (returns both totals)
const calculateGroupTotal = (group) => {
  let dr = 0,
    cr = 0;
  group.forEach((item) => {
    const val = parseFloat(item.balancec?.replace(/,/g, '')) || 0;
    if (item.drAmount > 0) dr += val;
    else cr += val;
  });
  return { dr, cr };
};

const DivisionOutStandingNew = () => {
  const {
    profitCenters,
    selectedProfitCenter,
    divoutdata,
    totalAmount,
    formData,
    cloading,
    errors,
    customeroptions,
    handleCustomerChange,
    handleInputChange,
    handleDownloadClick,
    handleProfitCenterChange
  } = DivisionWiseOutstandingControllerNew({ customer: '', profitCenter: '' }, validateLedgerCurrentYear);

  const formatIndianCurrency = (num) => {
    if (typeof num !== 'number') num = Number(num);
    return Math.abs(num).toLocaleString('en-IN');
  };

  // const filteredData = divoutdata.filter(item => {
  //   return item.crdr === 'Dr';
  // });

  const groupedData = groupBy(divoutdata, ['type', 'crdr']);
  // const groupedData = groupBy(divoutdata, ['postingDate']);
  const groupTotals = {};

  // Pre-calculate all group totals and accumulate overall totals
  Object.entries(groupedData).forEach(([key, group]) => {
    const totals = calculateGroupTotal(group);
    groupTotals[key] = totals;
  });

  return (
    <div className="bg" style={{ display: 'block' }}>
      {cloading && (
        <div className="overlay">
          <Loader />
          <span style={{ marginLeft: '10px' }}>Please Wait....</span>
        </div>
      )}
      <Container>
        <div className="cutrange">
          <span className="font20">Division Wise Outstanding</span>
        </div>

        <Grid container spacing={2} sx={{ mb: 2 }}>
          {JSON.parse(localStorage.getItem("user")).userVerticalId === "Garment" ? (
            // CASE 1: Garment user → Only Download button
            <Grid item xs={2}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={handleDownloadClick}
              >
                Download
              </Button>
            </Grid>
          ) : (
            // CASE 2 & 3: Non-Garment users
            <>
              {/* Party (Customer) Dropdown */}
              <Grid item xs={(profitCenters.length > 1) ? 5 : 10}>
                <Select
                  options={customeroptions}
                  value={formData.customer}
                  onChange={handleCustomerChange}
                  placeholder="Select Party"
                  isClearable
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                  onInputChange={handleInputChange}
                />
                {errors.customer ? (
                  <p className="error">{errors.customer}</p>
                ) : (
                  <p className="no-error">.</p>
                )}
              </Grid>

              {/* Profit Center Dropdown (only if >1 option) */}
              {profitCenters.length > 1 && (
                <Grid item xs={5}>
                  <Select
                    options={profitCenters}
                    value={selectedProfitCenter}
                    onChange={handleProfitCenterChange}
                    placeholder="Select Profit Center"
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                    onInputChange={handleInputChange}
                  />
                  {errors.profitCenter ? (
                    <p className="error">{errors.profitCenter}</p>
                  ) : (
                    <p className="no-error">.</p>
                  )}
                </Grid>
              )}

              {/* Download Button */}
              <Grid item xs={2}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={handleDownloadClick}
                >
                  Download
                </Button>
              </Grid>
            </>
          )}
        </Grid>


        <TableContainer component={Paper} sx={{ maxHeight: '500px', overflowY: 'auto' }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell align="center">Posting Date</TableCell>
                <TableCell align="center">Reference Doc. No</TableCell>
                <TableCell align="center">Fl Doc. No</TableCell>
                <TableCell align="center">Doc. Date</TableCell>
                <TableCell align="center">Profit Center</TableCell>
                <TableCell align="center">Type</TableCell>
                <TableCell align="center">Amount</TableCell>
                {/* <TableCell align="center">Cr/Dr</TableCell> */}
                <TableCell align="center">Bill No</TableCell>
                <TableCell align="center">Particular</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.keys(groupedData).length === 0 ? (
                <TableRow>
                  <TableCell align="center" colSpan={10}>
                    No Outstanding
                  </TableCell>
                </TableRow>
              ) : (
                 Object.entries(groupedData)
  .sort(([keyA], [keyB]) => {
    const isCrA = keyA.includes('Cr');
    const isCrB = keyB.includes('Cr');

    if (isCrA && !isCrB) return -1; // CR first
    if (!isCrA && isCrB) return 1;  // DR later
    return 0;
  })
  .map(([groupkey, group], idx) => (
                  <React.Fragment key={idx}>
                    {group.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell align="center">{row.postingDate}</TableCell>
                        <TableCell align="center">{row.referenceDocNo}</TableCell>
                        <TableCell align="center">{row.fiDoc}</TableCell>
                        <TableCell align="center">{row.docDate}</TableCell>
                        <TableCell align="center">{row.profitCentre}</TableCell>
                        <TableCell align="center">{row.type}</TableCell>
                        <TableCell align="center">{row.balance}</TableCell>
                        {/* <TableCell align="center">{row.crdr}</TableCell> */}
                        <TableCell align="center">{row.billNo}</TableCell>
                        <TableCell align="center">{row.particular}</TableCell>
                      </TableRow>
                    ))}
                    <TableRow sx={{ backgroundColor: '#e0e0e0' }}>
                      <TableCell align="center" colSpan={6} sx={{ fontWeight: 'bold' }}>
                        Total ({groupkey})
                      </TableCell>
                      <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                        {formatIndianCurrency(groupTotals[groupkey].dr - groupTotals[groupkey].cr)}
                      </TableCell>
                      <TableCell colSpan={3}></TableCell>
                    </TableRow>
                  </React.Fragment>
                ))
              )}
            </TableBody>

            <TableFooter>
              <TableRow>
                <TableCell colSpan={6} align="center" sx={{ fontWeight: 'bold' }}>
                  Grand Total
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                  {formatIndianCurrency(totalAmount)}
                </TableCell>
                <TableCell colSpan={3}></TableCell>
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Container>
    </div>
  );
};

export default DivisionOutStandingNew;
